import axios from 'axios';

export async function getShows(query: object) {
	return new Promise(resolve => {
		// Build Laravel web service URL.
		const restUrl = process.env.VUE_APP_LARAVEL_API.replace(/\/$/, "") + '/shows'

		// Returnable object
		let returnable: { status: number, statusText: string, data: object, totalResults: number, totalPages: number } = { status: 0, statusText: '', data: {}, totalResults: 0, totalPages: 0 };

		// Make request to get the menu data
		const ax = axios.post(restUrl, query)
			.then((response) => {
				returnable = {
					status: response.status,
					statusText: response.statusText,
					data: response.data.data,
					totalResults: (response.data.per_page && response.data.total) ? Math.abs(parseInt(response.data.per_page) * parseInt(response.data.total)) : 0,
					totalPages: parseInt(response.data.total || 0),
				}
				return resolve(returnable);
			})
			.catch((error) => {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					returnable = {
						status: error.response.status,
						statusText: error.response.data.message || error.response.data || 'Server error',
						data: {},
						totalResults: 0,
						totalPages: 0,
					}
					return resolve(returnable);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					returnable = {
						status: 444,
						statusText: 'No response from server',
						data: {},
						totalResults: 0,
						totalPages: 0,
					}
					return resolve(returnable);
				}

				// Something happened in setting up the request that triggered an Error
				returnable = {
					status: 999,
					statusText: error.message || 'Unknown error',
					data: {},
					totalResults: 0,
					totalPages: 0,
				}
				return resolve(returnable);
			})

		return ax;
	});
}
